const flexCheck = (styles) => {
  let stylearray = [styles];
  if ('flex' in styles) {
    if (styles.flex === 1) {
      stylearray = [styles, {flexBasis: 'auto'}];
    }
  }
  return stylearray;
};

export default flexCheck;
